// components/footer/olivierAwardsYear.js

const SEL = {
	filter: '#site-olivier-awards__controls-filter',
	jumpAward: '#site-olivier-awards__control-jump-award',
	jumpShow: '#site-olivier-awards__control-jump-show',

	catsWrap: '.site-olivier-awards__categories',
	showsWrap: '.site-olivier-awards__shows',

	award: '.site-olivier-awards__award',
	nominee: '.site-olivier-awards__nominee'
};

const qs = (root, sel) => root.querySelector(sel);
const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));
const setVisible = (el, vis) => {
	if (el) {
		el.style.display = vis ? '' : 'none';
	}
};

/**
 * Show/hide nominees (and awards) depending on mode: 'all' | 'winners'
 *
 * @param root
 * @param mode
 */
export function applyAwardsVisibility(root, mode = 'all') {
	qsa(root, SEL.award).forEach((award) => {
		const nominees = qsa(award, SEL.nominee);
		const winners = nominees.filter((n) => n.classList.contains('is-winner'));

		if (mode === 'winners') {
			if (winners.length === 0) {
				award.style.display = 'none';
				return;
			}
			award.style.display = '';
			nominees.forEach((n) => {
				n.style.display = n.classList.contains('is-winner') ? '' : 'none';
			});
		} else {
			award.style.display = '';
			nominees.forEach((n) => {
				n.style.display = '';
			});
		}
	});
}

/**
 * Toggle between awards view and shows grid
 *
 * @param root
 * @param val
 */
export function applyFilter(root, val) {
	const cats = qs(root, SEL.catsWrap);
	const shows = qs(root, SEL.showsWrap);
	const jumpAward = qs(root, SEL.jumpAward);
	const jumpShow = qs(root, SEL.jumpShow);

	if (val === 'shows') {
		setVisible(cats, false);
		setVisible(shows, true);
		setVisible(jumpAward, false);
		setVisible(jumpShow, true);
	} else {
		setVisible(cats, true);
		setVisible(shows, false);
		setVisible(jumpAward, true);
		setVisible(jumpShow, false);
		applyAwardsVisibility(root, val);
	}
}

/**
 * Smooth-scroll to selected anchor from a <select>
 *
 * @param root
 * @param selectEl
 */
export function handleJump(root, selectEl) {
	const id = selectEl?.value;
	if (!id) {
		return;
	}
	const target = root.getElementById ? root.getElementById(id) : document.getElementById(id);
	if (target) {
		const yOffset = -180; 
		const y = target.getBoundingClientRect().top + window.scrollY + yOffset;
		window.scrollTo({top: y, behavior: 'smooth'});
	}
}

/**
 * Boot the page
 *
 * @param root
 */
export default function initOlivierAwardsYear(root = document) {
	// Only run if this page actually has the controls
	if (!qs(root, '.site-olivier-awards__controls')) {
		return;
	}

	const filter = qs(root, SEL.filter);
	const jumpAward = qs(root, SEL.jumpAward);
	const jumpShow = qs(root, SEL.jumpShow);

	// Initial state
	applyFilter(root, 'all');

	filter?.addEventListener('change', (e) => applyFilter(root, e.target.value));
	jumpAward?.addEventListener('change', () => handleJump(root, jumpAward));
	jumpShow?.addEventListener('change', () => handleJump(root, jumpShow));

	if (location.hash) {
		const el = root.querySelector(location.hash);
		if (el) {
			el.scrollIntoView({ behavior: 'auto', block: 'start' });
		}
	}
}

export { SEL };
